<template>
  <label class="products-filter-field">
    <span><b-icon icon="search"></b-icon> جستجو</span>
    <input
      class="products-filter-input"
      @keypress.enter.prevent="search"
      @change="search"
      v-model="searchWords"
      placeholder="نام محصول..."
    >
  </label>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      searchWords: '',
    }
  },
  methods: {
    search() {
      let page = 1
      this.$store.commit('Product/setFilters', {key: 'search', value: this.searchWords})
      this.$emit('updateFilter', {search: this.searchWords})
      this.$store.dispatch("Product/setDashboardProducts", page);
    }
  },
  mounted() {
    const value = this.$route.query.search;
    if (value != undefined) {
      this.searchWords = value
      this.$store.commit('Product/setFilters', {key: 'search', value: value})
    }
  },
  destroyed() {
    this.$store.commit('Product/setFilters', {key: 'search', value: ''})
  }
}
</script>
